// Imports
import Events from '@utilities/events';

/**
 * Update Gtm Listing Filter events
 *
 * @return {Void}
 */
const updateGtmListingFiltersEvents = function() {
  // constants
  const JS_HOOK_PAGED_REFINEMENT_NAVIGATION = '[js-hook-paged-refinement-navigation]';
  const JS_HOOK_REFINEMENT_FILTER = '[js-hook-refinement-filter]';
  const JS_HOOK_REFINEMENT_VALUE = '[js-hook-refinement-value]';
  const refinementNavigation = document.querySelector(JS_HOOK_PAGED_REFINEMENT_NAVIGATION);

  if (refinementNavigation) {
    const refinementFilters = [...refinementNavigation.querySelectorAll(JS_HOOK_REFINEMENT_FILTER)];

    if (refinementFilters) {
      refinementFilters.forEach((el) => {
        el.addEventListener('click', () => {
          const value = el.querySelector(JS_HOOK_REFINEMENT_VALUE) ? el.querySelector(JS_HOOK_REFINEMENT_VALUE).innerText : null;
          let label = el.dataset.section;
          let action = el.getAttribute('aria-checked') ? el.getAttribute('aria-checked') : null;

          // data normalization
          switch (label) {
            case 'generalCover':{
              label = 'color';
              break;
            }
            case 'colorCode':{
              label = 'color';
              break;
            }
            case 'designers':{
              label = 'designer';
              break;
            }
            case 'By Price':{
              label = 'price';
              break;
            }
            default:
          }

          if (action) action = action === 'true' ? 'remove' : 'add';

          Events.$trigger('gtm::push', {
            data: {
              event: 'filter',
              label,
              value,
              action
            }
          });
        });
      });
    }
  }
};

export default updateGtmListingFiltersEvents;
